module.exports = __webpack_public_path__ + "static/media/fistFlexed2.600adfbc.png";